// extracted by mini-css-extract-plugin
export default {"LogoImage":"Logo_LogoImage__Hqxwc"};